"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = seriesSharedPercentageTooltipFormatterFactory;

require("core-js/modules/es6.array.find");

require("core-js/modules/es6.function.name");

var _styles = require("../styles");

var _coerce = _interopRequireDefault(require("@meltwater/coerce"));

var _defaultShortNumberFormatter = _interopRequireDefault(require("../../label-formatters/default-short-number-formatter"));

var _percentageLabelFormatter = _interopRequireDefault(require("../../label-formatters/percentage-label-formatter"));

require("../../chart-options/color-series-chart-options");

var _isHexColorValue = _interopRequireDefault(require("../../is-hex-color-value"));

var _index = require("../../index");

var ONE_HUNDO = 100;

function calculatePointKeyPercentage(allSeries, key) {
  var keyData = allSeries.map(function (series) {
    return {
      name: series.name,
      data: series.data.find(function (point) {
        return point.key === key;
      })
    };
  });
  var total = keyData.reduce(function (acc, point) {
    return acc + point.data.value;
  }, 0);
  var returnData = keyData.map(function (dataPoint) {
    dataPoint.data.percentage = dataPoint.data.value / total * ONE_HUNDO;
    return dataPoint;
  });
  return returnData;
}
/**
 * Produces a tooltip handler that returns HTML for a tooltip which summarizes the current key
 * (i.e. x-axis) showing all the point values and highlighting the current on.
 *
 * @param {SeriesData[]} series - The series to include in the tooltip
 * @param {ColorSeriesChartOptions} options - Options object specifying colors for the series
 *
 * @returns {MwChartNSeriesLineTooltipFormatter} - A formatter to provide as a chart option
 */


function seriesSharedPercentageTooltipFormatterFactory(_ref) {
  var series = _ref.series,
      options = _ref.options;

  if (!Array.isArray(series)) {
    throw new TypeError("Option for series must be an array. Provided value: ".concat(JSON.stringify(series)));
  }

  var allSeriesCoerced = series.map(function (seriesCandidate) {
    return (0, _coerce.default)(seriesCandidate, _index.SeriesData, "Items in series must be coerceable to SeriesData. Provided value: ".concat(JSON.stringify(seriesCandidate)));
  });

  if (!options || !options.seriesColors || !Array.isArray(options.seriesColors) || options.seriesColors.length < series.length || options.seriesColors.some(function (color) {
    return !(0, _isHexColorValue.default)(color);
  })) {
    throw new TypeError("Option for seriesColors must be provided as an array of hex values. Provided value: ".concat(JSON.stringify(options.seriesColors)));
  }

  var seriesColors = options.seriesColors;
  return function (_ref2) {
    var _ref2$hiddenSeriesInd = _ref2.hiddenSeriesIndices,
        hiddenSeriesIndices = _ref2$hiddenSeriesInd === void 0 ? [] : _ref2$hiddenSeriesInd,
        key = _ref2.key,
        seriesName = _ref2.seriesName;
    var shownSeries = allSeriesCoerced.filter(function (__, index) {
      return !hiddenSeriesIndices.some(function (element) {
        return element === index;
      });
    });
    var shownSeriesColors = seriesColors.filter(function (__, index) {
      return !hiddenSeriesIndices.some(function (element) {
        return element === index;
      });
    });
    var allPoints = calculatePointKeyPercentage(shownSeries, key); // eslint-disable-next-line prefer-template

    return "<b>".concat(key, "</b><br/>") + allPoints.map(function (_ref3, index) {
      var name = _ref3.name,
          data = _ref3.data;
      var value = data.value;
      var pointPercentage = data.percentage;
      var itemHoverClass = '';

      if (seriesName === name) {
        itemHoverClass = _styles.ACTIVE_SERIES_CLASS;
      }

      var seriesColor = shownSeriesColors[index];
      return "<div class=\"".concat(_styles.SERIES_CLASS, " ").concat(itemHoverClass, "\">\n                            <span style=\"color:").concat(seriesColor, "\">\u25CF </span>").concat(name, ": <b>").concat((0, _defaultShortNumberFormatter.default)(value), " (").concat((0, _percentageLabelFormatter.default)(pointPercentage), ")</b>\n                        </div>");
    }).join('');
  };
}